import axiosInstance from "../../../utils/axios";

const path = "common"

export const GetSkyFlowData = async (values) => {
    return await axiosInstance().post(`${path}/skyflow-reveal-details`, values);
}